module.exports = __webpack_public_path__ + "img/1740015925101-Screenshot 2025-02-20 094538.png.9415d22f.webp";